<template>
    <Head :title="pageTitle"/>
    <google-analytics-inertia/>
    <FlashMessages/>
    <HoneybadgerErrorTracking/>
    <div class="flex min-h-screen flex-col">
        <group-header v-if="!hideHeader"/>

        <main class="flex flex-grow bg-white">
            <div class="hidden w-[200px] bg-gray-250 pt-8 lg:flex">
                <ul>
                    <Link
                        v-for="item in menuItems"
                        as="li"
                        :href="route(item.link)"
                        :class="
                            'leading-0 flex w-[200px] items-center gap-2 border-l-4 p-4 hover:cursor-pointer' +
                            ' ' +
                            (isActive(item)
                                ? 'border-l-blue-500 bg-gray-450'
                                : 'border-l-transparent')
                        "
                    >
                        <div
                            :class="
                                isActive(item.link)
                                    ? 'text-blue-500'
                                    : 'text-gray-750'
                            "
                        >
                            <inline-svg
                                :src="item.iconSrc"
                                class="h-6 w-6 fill-current"
                            ></inline-svg>
                        </div>
                        <div>{{ item.name }}</div>
                    </Link>
                </ul>
            </div>
            <div class="max-w-full flex-grow px-4 py-12 lg:px-24">
                <div class="">
                    <div v-if="$slots.page_header" class="w-full">
                        <slot name="page_header"/>
                    </div>
                    <div v-else class="mb-8 flex w-full justify-between">
                        <h1 class="text-[28px] font-bold" v-if="pageTitle">
                            <span
                                class="flex items-center"
                                v-html="pageTitle"
                            />
                        </h1>
                        <div v-if="$slots.page_controls" class="">
                            <slot name="page_controls"></slot>
                        </div>
                    </div>
                    <div class="px-1">
                        <slot/>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import GroupHeader from "@/Components/GroupHeader";
import InlineSvg from "vue-inline-svg";
import FlashMessages from "@/Components/FlashMessages";
import GoogleAnalyticsInertia from "@/Components/GoogleAnalyticsInertia.vue";
import HoneybadgerErrorTracking from "@/Components/HoneybadgerErrorTracking.vue";

export default {
    name: "GroupBackendLayout",
    components: {
        HoneybadgerErrorTracking,
        GoogleAnalyticsInertia,
        FlashMessages,
        InlineSvg,
        GroupHeader,
    },
    props: {
        hideHeader: {
            type: Boolean,
            default: false,
        },
        pageTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            menuItems: this.$page.props.menuItems,
        };
    },
    methods: {
        isActive(link) {
            return _.find(link.activeRoutes, function (activeRoute) {
                return _.startsWith(route().current(), activeRoute);
            });
        },
    },
};
</script>

<style scoped></style>
